import { Card, Space } from 'antd';
import { FC, memo } from 'react';

import { DomainRegistrarAccountsCreateForm } from '../DomainRegistrarAccountsForm';
import { DomainRegistrarAccountsList } from '../DomainRegistrarAccountsList';

interface Props {
  domainRegistrarId: string;
}

export const DomainRegistrarAccountsOverviewView: FC<Props> = memo(({ domainRegistrarId }) => {
  return (
    <Card>
      <Space direction="vertical" size="small" className="ant-space-fullwidth">
        <DomainRegistrarAccountsCreateForm domainRegistrarId={ domainRegistrarId }/>

        <DomainRegistrarAccountsList domainRegistrarId={ domainRegistrarId }/>
      </Space>
    </Card>
  );
});
